import { mutator } from 'satcheljs';
import { activityFeedItemsSeen } from '../actions/activityFeedItemsSeen';
import { markItemsAsSeen } from '../service/markItemsAsSeen';

mutator(activityFeedItemsSeen, ({ itemIds, resetUnseenCount }) => {
    markItemsAsSeen(itemIds, resetUnseenCount);
});
